/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Orders_DeliveredInputs */

const vi_report_orders_delivered = /** @type {(inputs: Report_Orders_DeliveredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã giao`)
};

/**

* @param {Report_Orders_DeliveredInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_orders_delivered = /** @type {((inputs?: Report_Orders_DeliveredInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Orders_DeliveredInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_orders_delivered(inputs)
});